

import React from 'react';
import { XIcon, InfoIcon } from 'shared-icons';

interface InfoPageModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}

const InfoPageModal: React.FC<InfoPageModalProps> = ({ isOpen, onClose, title, content }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-slate-900/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="info-page-title"
      style={{ animation: 'modal-fade-in 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)' }}
    >
      <div
        className="bg-white dark:bg-slate-800 border dark:border-slate-700 rounded-xl shadow-2xl w-full max-w-2xl flex flex-col max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
        style={{ animation: 'modal-content-pop 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)' }}
      >
        {/* Header */}
        <div className="flex-shrink-0 p-6 pb-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <InfoIcon className="w-6 h-6 text-cyan-500 dark:text-cyan-400" />
              <h3 id="info-page-title" className="text-xl font-bold text-slate-800 dark:text-slate-100">{title}</h3>
            </div>
            <button onClick={onClose} className="text-gray-400 dark:text-slate-400 hover:text-gray-800 dark:hover:text-white text-3xl leading-none" aria-label="Close modal">&times;</button>
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto px-6 pb-6 text-slate-600 dark:text-slate-300 space-y-4">
            {content}
        </div>
      </div>
    </div>
  );
};

export default InfoPageModal;